import AxiosControl from '../components/axios/AxiosControl'
import { toastSuccess, toastError } from '../components/swal/toast'
const Axios = AxiosControl()

export const getLeaveRequests = () => async (dispatch) => {
    dispatch({ type: 'EMPLOYMENT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/employment/requests', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'LEAVE_REQUESTS_SUCCESS', payload: data.requests })
        }
    } catch (error) {
        dispatch({ type: 'EMPLOYMENT_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const createLeaveRequest = (request) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/employment/requests', request, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'LEAVE_REQUEST_ADD_SUCCESS', payload: data.request })
            toastSuccess(data.message || 'Solicitud registrada correctamente')
            return true
        }
        return false
    } catch (error) {
        toastError(error.response?.data?.message || 'Error al registrar la solicitud')
        return false
    }
}

export const cancelLeaveRequest = (id) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/teacher/employment/requests/' + id, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'LEAVE_REQUEST_DELETE_SUCCESS', payload: id })
            toastSuccess(data.message || 'Solicitud cancelada correctamente')
            return true
        }
        return false
    } catch (error) {
        toastError(error.response?.data?.message || 'Error al cancelar la solicitud')
        return false
    }
}
